const API_BASE = process.env.REACT_APP_API_URL || "http://localhost:8000";

export function answerBluffWsUrl(websocketPath: string): string {
  try {
    const u = new URL(API_BASE);
    const proto = u.protocol === "https:" ? "wss:" : "ws:";
    const path = websocketPath.startsWith("/") ? websocketPath : `/${websocketPath}`;
    return `${proto}//${u.host}${path}`;
  } catch {
    const path = websocketPath.startsWith("/") ? websocketPath : `/${websocketPath}`;
    return `ws://localhost:8000${path}`;
  }
}

/** Public join URL for QR (same origin; room + ws path in query). */
export function buildAnswerBluffJoinUrl(code: string, websocketPath: string): string {
  const origin = typeof window !== "undefined" && window.location?.origin ? window.location.origin : "";
  const u = new URL(`${origin}/party/join/bluff`);
  u.searchParams.set("code", code);
  u.searchParams.set("ws", websocketPath);
  return u.toString();
}
